// John Eldhose 20200521
import React, { Component } from 'react';
import { Button, Grid, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { ChevronLeft, Cancel } from '@material-ui/icons';
import ProfileAddress from '../lib/ProfileAddress';
import Checkout from '../lib/Checkout';
import { unsubscribe } from '../../Api/unsubscribe';

class Subscription extends Component {

  state = {
    profile: null,
    address: null,
    baddress: null,
    message: (['Subscribe', 'Unsubscribe'].includes(this.props.subscription.plan) ? '' : 'Unknown plan selected')
  }
  handleSubscribe = (co) => {
//    this.setState({ message: 'Subscription processed successfully' });
  }
  handleUnsubscribe = () => {
    unsubscribe({ sn: this.props.subscription.serial })
      .then((unsub) => {
        if(unsub.status === 'true')
          this.setState({ message: 'Unsubscribe completed successfully' });
        else
          this.setState({ message: 'Unsubscribe failed complete' });
      })
      .catch((error) => { console.log(error); });
  }

  render() {
    if(this.state.message !== '')
      return (
        <div>
          <Typography variant='display1'>
            <center><font color='#385687'>Subscription Status</font></center>
          </Typography>
          <p />
          <Typography>{this.state.message}</Typography>
        </div>
      );
    else if(this.props.subscription.plan === 'Subscribe') {
      if(this.state.address === null)
        return (
          <ProfileAddress
            Back={() => this.setState({ address: null }, this.props.back())}
            Continue={(p, a, b) => this.setState({ profile: p, address: a, baddress: b })}
          />
        );
      else
        return (
          <Checkout
            plan='Subscription'
            checkout={[this.props.subscription]}
            profile={this.state.profile}
            address={this.state.address}
            baddress={this.state.baddress}
            completed={this.handleSubscribe}
          />
        );
    }
    else if(this.props.subscription.plan === 'Unsubscribe')
      return (
        <div>
          <Typography variant='display1'>
            <center><font color='#385687'>Confirm Unsubscription</font></center>
          </Typography>
          <p />
          <List>
            <Grid container>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <ListItem>
                  <ListItemText
                    primary="Product"
                    secondary={this.props.subscription.name}
                  />
                </ListItem>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <ListItem>
                  <ListItemText
                    primary="Serial Number"
                    secondary={this.props.subscription.serial}
                  />
                </ListItem>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <ListItem>
                  <ListItemText
                    primary="Plan"
                    secondary="Subscription"
                  />
                </ListItem>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <ListItem>
                  <ListItemText
                    primary="Statue"
                    secondary="Subscribed"
                  />
                </ListItem>
              </Grid>
            </Grid>
          </List>
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}
              style={{ textAlign: 'left'}}
            >
              <Button
                color='secondary'
                onClick={this.props.back}
              >
                <ChevronLeft /> &nbsp; Go Back
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}
              style={{ textAlign: 'right'}}
            >
              <Button
                variant='raised'
                color='primary'
                onClick={this.handleUnsubscribe}
              >
                <Cancel /> &nbsp; Unsubscribe
              </Button>
            </Grid>
          </Grid>
        </div>
      );
  }
}

export default Subscription;



// WEBPACK FOOTER //
// ./src/components/lib/Subscription.js